import { IUser } from "@karma-games/angular-devkit/src/lib/modules/user";
import { Store } from "@karma-games/angular-devkit/src/lib/extended-store";

export namespace CurrencyUtils {
    export const getCurrencyFromUser = (store: Store): string => {
        const user: IUser = store.selectUser();
        return user.currency ?? "USD";
    }
}
